import { RootState } from 'models';

const getVisibility = (state: RootState) => state.modal.isVisible;

const getActionType = (state: RootState) => state.modal.actionType;

const getModalProps = (state: RootState) => state.modal.modalProps;

const getModal = (state: RootState) => state.modal;

export default {
  getVisibility,
  getActionType,
  getModalProps,
  getModal,
};
